var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRifle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#6740E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5568 9.00545L29.1909 8L13.8369 13.5884L16.4368 13.8317C16.6824 13.7123 16.9339 13.5998 17.1982 13.5036L29.5568 9.00545Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.477 14.3864L12.786 14.1344C12.9167 15.6211 11.302 17.3518 8.83043 18.2619L2.49719 22.3736L5.50133 26.0598L12.9814 19.8105C12.4189 17.9051 13.4731 15.7532 15.477 14.3863L15.477 14.3864Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4181 14.107C17.3001 14.15 17.1878 14.1989 17.0742 14.247C17.1826 15.4563 15.7146 17.0053 13.5777 17.9275C13.518 18.1728 13.4824 18.4186 13.4762 18.6642C16.2339 17.5975 17.9964 15.6336 17.6936 14.0068L17.4181 14.107Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRifle);
export default __webpack_public_path__ + "static/media/Rifle.467d1e6266c8e51bb1f9315c4cce1c1a.svg";
export { ForwardRef as ReactComponent };